import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { AuthProvider } from './contexts/AuthContext';
import { SpacesProvider } from './contexts/SpacesContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import SpacesPage from './pages/SpacesPage';
import AvailabilityPage from './pages/AvailabilityPage';
import BookingPage from './pages/BookingPage';
import BookingCompletePage from './pages/BookingCompletePage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import SupportPage from './pages/SupportPage';
import AdminBookingDetailPage from './pages/AdminBookingDetailPage';
import AdminMemberBookingsPage from './pages/AdminMemberBookingsPage';
import MeetingRoomDisplayPage from './pages/MeetingRoomDisplayPage';
import PaymentPage from './pages/PaymentPage';

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SpacesProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { fontFamily: 'Inter, sans-serif', fontSize: '14px' },
            success: { iconTheme: { primary: '#f97316', secondary: '#fff' } },
          }}
        />
        <Routes>
          {/* Public routes with nav/footer */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/spaces" element={<Layout><SpacesPage /></Layout>} />
          <Route path="/availability" element={<Layout><AvailabilityPage /></Layout>} />
          <Route path="/book" element={<Layout><BookingPage /></Layout>} />
          <Route path="/booking-complete" element={<Layout><BookingCompletePage /></Layout>} />
          <Route path="/pay" element={<PaymentPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout><DashboardPage /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/support"
            element={
              <ProtectedRoute>
                <Layout><SupportPage /></Layout>
              </ProtectedRoute>
            }
          />

          {/* Admin (protected) */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/booking/:bookingId"
            element={
              <ProtectedRoute>
                <AdminBookingDetailPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/member/:memberId"
            element={
              <ProtectedRoute>
                <AdminMemberBookingsPage />
              </ProtectedRoute>
            }
          />

          {/* Meeting room display (iPad wall-mount, passcode-protected) */}
          <Route path="/display/meeting-room" element={<MeetingRoomDisplayPage />} />

          {/* 404 fallback */}
          <Route path="*" element={
            <Layout>
              <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
                <div className="text-6xl font-extrabold text-gray-200 mb-4">404</div>
                <h1 className="text-2xl font-bold text-slate-700 mb-2">Page not found</h1>
                <p className="text-slate-400 mb-6">The page you're looking for doesn't exist.</p>
                <a href="/" className="btn-primary">Back to Home</a>
              </div>
            </Layout>
          } />
        </Routes>
        </SpacesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
